import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function EditPersonalInfoSpouse() {

    const location = useLocation();
    const navigate = useNavigate();

    const { menu, toggleMobileMenu } = useAppLayout();

    const editMemberId = location.state?.editMemberId;
    const memberId = location.state?.memberId;

    //console.log("Member ID is : ",memberId);

    const queryClient = useQueryClient();

    const [message, setMessage] = useState('');
    
    const [profile, setProfile] = useState({
        name: '',
        last_name: '',
        surname: '',
        n_prefix: '',
        date_of_birth: '',
        gender: '',
        status: '',
        profile_image: ''
        });

      const {
        data,
        isLoading,
        isError,
      } = useQuery({
        queryKey: ['userProfileDetails', editMemberId],
        queryFn: async () => {
          if (!editMemberId) throw new Error("No memberId provided");
      
          const res = await axios.get(`${API_URL}/edit-personalinfospouse-settings-api?memberId=${editMemberId}`, {
            withCredentials: true,
          });
      
          return res.data;
        },
        enabled: !!editMemberId, // prevent fetch if memberId is undefined
        staleTime: 0,
        cacheTime: Infinity,
      });
      


     useEffect(() => {
        if (data) {
          if (data.Status === "Success") {
            const user = data.user;
      
            setProfile({
                name: user.name || '',
        last_name: user.last_name || '',
        surname: user.surname || '',
        n_prefix: user.n_prefix || '',
        date_of_birth: user.date_of_birth ? user.date_of_birth.substring(0, 10) : '',
        gender: user.gender || '',
        status: user.status || '',
        profile_image: user.profile_image || '',
            });
          } else {
            setMessage("Failed to load user data");
          }
        }
      }, [data]);


    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    
const [previewImage, setPreviewImage] = useState(null);

const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    try {
      const targetKB = 100;
      let quality = 0.9;
      let compressedFile = file;
  
      while (true) {
        const options = {
          maxSizeMB: targetKB / 1024,
          maxWidthOrHeight: 800, // Optional resize dimension
          initialQuality: quality,
          useWebWorker: true,
        };
  
        compressedFile = await imageCompression(file, options);
        
        // Break if under target size or quality is too low
        if (compressedFile.size / 1024 <= targetKB || quality <= 0.1) break;
        quality -= 0.1;
      }
  
      // Generate preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(compressedFile);
  
      // Update compressed image in state
      setProfile((prev) => ({
        ...prev,
        profile_image: compressedFile,
      }));
    } catch (err) {
      console.error('Image compression error:', err);
      toast.error('Failed to compress image.');
    }
  };


const handleProfileUpdate = async () => {
    const formData = new FormData();

    // If no new image is selected, pass the current image name to the backend
    if (profile.profile_image) {
        formData.append('image_name', profile.profile_image);
    }

    // Append the rest of the profile fields except the image
    Object.keys(profile).forEach((key) => {
        if (key !== 'profile_image') {
            formData.append(key, profile[key]);
        }
    });

    try {
        const response = await axios.put(
            `${API_URL}/edit-personalinfospouse-settings-update-api?memberId=${editMemberId}`,  // ✅ add memberId to query
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }
        );

        toast.success("Details updated successfully");

       navigate('/family-tree-spouse', { state: { memberId } });

    } catch (error) {
        toast.error("Error updating profile");
        console.error('Error updating profile:', error);
    }
};



    return (
         
        <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

         <div className="page-wrapper">
         <div className="content container-fluid">

            <div className="row mt-3">

            <div className="col-md-12">

            <div className="card">
                <div className="card-body">

                        <div className="row">
                        <div className="col-md-12">
                            <center>
                            <div 
                                className="position-relative d-inline-block" 
                                style={{ cursor: 'pointer' }} 
                                onClick={() => document.getElementById('uploadImageInput').click()}
                            >
                                {profile.profile_image && (
                                <div className="mb-3">
                                    <img 
                                    src={previewImage || `${API_URL}/images/${profile.profile_image}`} 
                                    alt="Profile" 
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', 
                                        border: '2px solid #ccc' 
                                    }}
                                    />
                                </div>
                                )}

                                {/* Edit Icon */}
                                <span 
                                className="avatar-edit bg-transparent shadow-none" 
                                style={{ position: 'absolute', bottom: '5px', right: '5px', 
                                    backgroundColor: '#fff', borderRadius: '50%', padding: '6px', 
                                    boxShadow: '0px 0px 5px rgba(0,0,0,0.2)'
                                }}
                                >
                                <i className="fas fa-edit" style={{ color: '#184A2C', fontSize: '16px' }}></i>
                                </span>

                                {/* Hidden Input */}
                                <input 
                                id="uploadImageInput" 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                style={{ display: 'none' }}
                                />
                            </div>
                            </center>
                        </div>
                        </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="control-label">First Name</label>
                    <input type="text" name="name" value={profile.name} onChange={handleChange} placeholder="First Name" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Last Name</label>
                    <input type="text" name="last_name" value={profile.last_name} onChange={handleChange} placeholder="Last Name" className="form-control mb-2" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="control-label">Surname</label>
                    <input type="text" name="surname" value={profile.surname} onChange={handleChange} placeholder="Surname" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Prefix</label>
                    <input type="text" name="n_prefix" value={profile.n_prefix} onChange={handleChange} placeholder="Name Prefix" className="form-control mb-2" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="control-label">Your Birthday</label>
                    <input type="date" name="date_of_birth" value={profile.date_of_birth} onChange={handleChange} className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    
                    </div>
                </div>
                

                <div className="row">
                    <div className="col-6 col-md-6">
                    <button type="submit" className="btn btn-primary"  onClick={handleProfileUpdate}>Update Personal Information</button>
                    </div>
                    <div className="col-6 col-md-6">
                    
                    </div>
                </div>




                </div>
                </div>

                

        

                </div>

            </div>


            <div className='row end-page-space' >  </div>

            </div>
            </div>
        
        </div>
        
    );
}

export default EditPersonalInfoSpouse;
